goog.provide("shadow.js.shim.module$$carbon$icons_react$es$ArrowLeft$default");
shadow.js.shim.module$$carbon$icons_react$es$ArrowLeft$default = shadow.js.require(349, {}).default;
